import { CSSObject } from '@emotion/react'
import { responsiveContainerPadding } from '../../../utils/breakpoints'

export const multiSelectGridStyles = (): {
  [key: string]: Record<string, CSSObject | string | number>
} => ({
  container: {
    width: '90%',
    background: '#fff',
    padding: 30,
    boxSizing: 'border-box',
    ...responsiveContainerPadding(30),
  },
  label: {
    fontSize: 18,
    fontFamily: 'Gilroy-Regular',
    marginBottom: 16, // Added for better spacing
  },
  gridContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    gap: '8px',
    width: '100%',
    margin: 'auto',
  },
  buttonWrapper: {
    width: '45%', // Matching your button's width
  },
})
